import en from './lang/en.json';

export default en.translation;
